import React from "react";
import { useMeals } from "../Meal/MealsContext";

function UpdateQuantityPackage({ packageMeal }) {
  const { setCart, cart } = useMeals();

  const cartItem = cart.find((item) => item.meal.id === packageMeal.id);
  const quantity = cartItem ? cartItem.quantity : "";

  const handleQuantityChange = (e) => {
    const newQuantity = Number(e.target.value);

    setCart((prevCart) => {
      let updatedCart = [...prevCart];
      const existingItemIndex = updatedCart.findIndex(
        (cartItem) => cartItem.meal.id === packageMeal.id
      );

      if (existingItemIndex !== -1) {
        if (newQuantity > 0) {
          updatedCart[existingItemIndex].quantity = newQuantity;
        } else {
          updatedCart = updatedCart.filter(
            (_, idx) => idx !== existingItemIndex
          );
        }
      } else if (newQuantity > 0) {
        updatedCart.push({ meal: packageMeal, quantity: newQuantity });
      }

      return updatedCart;
    });
  };

  return (
    <select
      value={quantity}
      onChange={handleQuantityChange}
      className="border border-gray-300 rounded-md text-center w-10"
    >
      <option value=""></option>
      {[...Array(50).keys()].map((n) => (
        <option key={n + 1} value={n + 1}>
          {n + 1}
        </option>
      ))}
    </select>
  );
}

export default UpdateQuantityPackage;
